let backendHost;

const hostname = window && window.location && window.location.hostname;

if (hostname === 'localhost') {
    backendHost = 'http://localhost:9090';
} else if (hostname === 'greenhaven.thewebpeople.ca') {
    backendHost = 'https://driver.thewebpeople.ca';
} else {
    backendHost = 'https://driver.thewebpeople.ca/';
}

export const API_ROOT = `${backendHost}/api`;